













import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import JobsearchListingSearchBox from "@/components/jobsearch/JobsearchListingSearchBox.vue";
import { JobsearchListingSearchParams } from "@/components/jobsearch/JobsearchListingSearchBox.vue";

import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import JobsearchListingTable from "@/views/jobsearch/JobsearchListingTable.vue";
import { PortalJobsearchListing } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    JobsearchListingSearchBox,
    AppAuthButton,
    JobsearchListingTable,
  },
})
export default class extends Mixins(AxiosMixin) {
  private listings: PortalJobsearchListing[] = [];

  private fetchList(searchObj: JobsearchListingSearchParams): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_jobsearch_listings/get",
      searchObj,
      (res) => {
        this.listings = res.data.listings || [];
      }
    );
  }
}
